import api from 'state/axios';


const extractError = (err) => {
    const msg = err.response?.data?.message || err.message;
    const status = err.response?.status;
    return new Error(`${msg} (status: ${status})`);
};

export const fetchParams = async () => {
    const response = await api.get('/params');
    return response.data;
};

export const fetchCrewRanks = async () => {
    const response = await api.get('/ranks/active');
    return response.data;
};

export const fetchPermissions = async (userId) => {
    const response = await api.get(`/users/${userId}/permissions`);
    return response.data.permissionsList;
};

export const fetchFlights = async (startDate, endDate) => {
    const response = await api.post(
        '/flights', 
        { startDate, endDate }
    );
    return response.data;
};

export const fetchCrewRoutes = async (startDate, endDate) => {
    const response = await api.post(
        '/crewroutes/legmembers', 
        { startDate, endDate }
    );
    return response.data;
};

export const fetchCrewBlockHours = async (startDate, endDate) => {
    const response = await api.post(
        '/legmembers/getcrewsummary', 
        { startDate, endDate }
    );
    return response.data;
};

export const fetchCrewTotalHours = async (startDate, endDate) => {
    const response = await api.post(
        '/rosterdetails/rostersummary', 
        { startDate, endDate }
    );
    return response.data;
};

export const fetchLegMembersById = async (id) => {
    const response = await api.get(`/flights/legmembers/${id}`);
    return response.data;
};

export const fetchLegMembersByFlt = async (flightDate, flightDesc, dep) => {
    const response = await api.post(
        '/flights/legmembersbyflt', 
        { flightDate, flightDesc, dep }
    );
    return response.data;
};

export const fetchLegMembersByCrewCode = async (crewCode, startDate, endDate) => {
    const response = await api.get(
        `/legmembers/legmembersbycrewcode/${crewCode}`, 
        { params: { startDate, endDate } }
    );
    return response.data;
};

export const fetchGroupedLegMembersByCrewCode = async (crewCode, startDate, endDate) => {
    if (!crewCode || !startDate || !endDate) return null;
    try {
        const response = await api.get(
            `/legmembers/groupedlegmembersbycrewcode/${crewCode}`, 
            { params: { startDate, endDate } }
        );
        return response.data;
    } catch (err) {
        throw extractError(err);
    }
};

export const fetchRosterDetailsByCrewCode = async (crewCode, startDate, endDate) => {
    const response = await api.get(
        `/rosterdetails/rosterdetailsbycrewcode/${crewCode}`, 
        { params: { startDate, endDate } }
    );
    return response.data;
};

export const fetchGroupedRosterDetailsByCrewCode = async (crewCode, startDate, endDate) => {
    const response = await api.get(
        `/rosterdetails/groupedrosterdetailsbycrewcode/${crewCode}`, 
        { params: { startDate, endDate } }
    );
    return response.data;
};

export const fetchJumpSeaters = async (startDate, endDate) => {
    const response = await api.post(
        '/jumpseaters', 
        { startDate, endDate }
    );
    return response.data;
};
